






























































































import { Session } from '../../../utils/Session';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getBuildingName } from '../../../../src_server/entity/master/buildingData';
import { routeHelper } from '../../../utils/routeHelper';
@Component({ components: {} })
export default class NoData extends Vue {
  private buildingName = '';

  toMyPage() {
    routeHelper(this, 'StudentSettingMain');
  }

  created() {
    const building_id = Session.getSessionBuildingId();
    this.buildingName = getBuildingName(building_id);
  }
}
